import api from "app/api";
import { Options } from "common";

export interface NotificationAddressItem {
  id: number;
  key: string;
  user_ids: number[] | null;
  external_emails: string[] | null;
  send_email: boolean | null;
  send_push: boolean | null;
  created_by?: number | null;
  updated_by?: number | null;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export type NotificationAddressOptions = Options<never>;

export function getNotificationAddressService(scope?: any) {
  return api.getService<
    NotificationAddressItem,
    NotificationAddressItem,
    NotificationAddressOptions
  >("notification-addresses", { scope });
}
